import { render } from "./UserPagination.vue?vue&type=template&id=348f7724"
import script from "./UserPagination.vue?vue&type=script&lang=js"
export * from "./UserPagination.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__